'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dPolicy$002dPage$0024 from "./presto.-Edit-Policy-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002459 from "./presto.-Presto-Router$$anon$59.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dCode$0024 from "./presto.types$-Policy-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$58() {
  this.bkF = null;
  this.bkx = null;
  this.bky = false;
  this.bkG = null;
  this.bkH = false;
  this.bkK = null;
  this.bkD = null;
  this.bkE = false;
  this.bkz = null;
  this.bkA = false;
  this.bkB = null;
  this.bkC = false;
  this.bkI = false;
  this.bkJ = false;
  this.bkF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bkK = "EditPolicyPage";
}
export { $c_Lpresto_PrestoRouter$$anon$58 as $c_Lpresto_PrestoRouter$$anon$58 };
$p = $c_Lpresto_PrestoRouter$$anon$58.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$58;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$58() {
}
export { $h_Lpresto_PrestoRouter$$anon$58 as $h_Lpresto_PrestoRouter$$anon$58 };
$h_Lpresto_PrestoRouter$$anon$58.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bkF;
});
$p.L = (function() {
  if ((!this.bky)) {
    this.bkx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bky = true;
  }
  return this.bkx;
});
$p.O = (function() {
  if ((!this.bkH)) {
    this.bkG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bkH = true;
  }
  return this.bkG;
});
$p.E = (function() {
  return this.bkK;
});
$p.t = (function() {
  if ((!this.bkE)) {
    this.bkD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bkE = true;
  }
  return this.bkD;
});
$p.M = (function() {
  if ((!this.bkA)) {
    this.bkz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dCode$0024.$m_Lpresto_types$PolicyCode$().SQ(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bkA = true;
  }
  return this.bkz;
});
$p.Q = (function() {
  if ((!this.bkC)) {
    this.bkB = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002459.$c_Lpresto_PrestoRouter$$anon$59();
    this.bkC = true;
  }
  return this.bkB;
});
$p.w = (function() {
  if ((!this.bkJ)) {
    this.bkI = false;
    this.bkJ = true;
  }
  return this.bkI;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee437) => ((p) => \u03b4scrutinee437.cG6(p)))($j_presto$002e$002dEdit$002dPolicy$002dPage$0024.$m_Lpresto_EditPolicyPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$58, "presto.PrestoRouter$$anon$58", ({
  Oq: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$58 as $d_Lpresto_PrestoRouter$$anon$58 };
//# sourceMappingURL=presto.-Presto-Router$$anon$58.js.map
